// 统一请求路径前缀在libs/axios.js中修改
import {get, post} from '@/network/db';

//登录接口
export const userLogin = (params) => {
    return post('/manager/passport/user/notVerificationLogin', params)
}

//退出登录
export const passportUserLogout = () => {
    return post('/manager/passport/user/logout')
}

//获取用户信息
export const passportUserInfo = () => {
    return get('/manager/passport/user/info')
}